<template>
  <div>
    <van-uploader :after-read="afterRead" />
    <van-row type="flex" v-for='item in imgList' :key='item.id'>
      <van-col span="20">
        <viewer id="imageUrlsCourseSource">
          <img :src="BACKEND_API + '/' + item.path + '?token=' + token"
                :key="item.id" width="95%" height="150" @click="onClickImg">
        </viewer>
      </van-col>
      <van-col span="4" v-if='!isReplied && item.create_id == empId'>
        <van-button size="mini" plain type="danger" native-type="button"
          style="width:100%;height:40px;" @click="del(item)">删除</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { presidentMailUpload, presidentMailFileList, presidentMailFileDel, presidentMailList } from '@/api/presidentMailbox';
import { getToken } from '@/utils/auth';
import Vue from 'vue';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
});
export default {
  name: 'MailUploader',
  data() {
    return {
      imgList: null,
      canUpload: null,
      uploading: null,
      uploadingPercentage: null,
      token: getToken(),
      sI: null,
      empId: this.$store.getters.userInfo.emp_id
    }
  },
  props: {
    data: {
      type: Object,
      default: () => new Object()
    },
    isReplied: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickImg() {
      this.sI = setInterval(() => {
        const obj = document.getElementsByClassName('viewer-container');
        if (obj && obj.length) {
          const arr = Array.from(obj);
          arr.forEach(item => {
            item.style.zIndex = 999999;
          });
          clearInterval(this.sI);
        }
      }, 100);
    },
    async afterRead(file) {
      const list = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      if (!list.includes(file.file.type)) {
        this.error('只支持图片上传');
        return;
      }
      const data = new FormData();
      data.append('id', this.data.id);

      const img = await this.lrz(file.file);
      data.append('file', img.file, file.file.name);
      data.append('token', this.token);

      presidentMailUpload(data).then(
        resp => {
          if (resp && resp.success) {
            this.success(resp.msg);

            const data_ = { id: this.data.id };
            presidentMailList(data_).then(
              resp => {
                if (resp && resp.success) {
                  this.data.file_ids = resp.rows[0].file_ids;
                  this.getFileList();
                }
              }
            );
          }
      });
    },
    getFileList() {
      // console.log(123, this.data)
      const data = { ids: this.data.file_ids || '不传ids会都查出来', rows: 99999 };
      presidentMailFileList(data).then(
        resp => {
          if (resp && resp.success) {
            this.imgList = resp.rows;
          }
        }
      );
    },
    del(file) {
      const data = {
        id: this.data.id,
        file_id: file.id
      }
      presidentMailFileDel(data).then(
        resp => {
          if (resp && resp.success) {
            this.success(resp.msg);

            const data_ = { id: this.data.id };
            presidentMailList(data_).then(
              resp => {
                if (resp && resp.success) {
                  this.data.file_ids = resp.rows[0].file_ids;
                  this.getFileList();
                }
              }
            );
          }
        }
      );
    }
  },
  created() {
    this.getFileList();
    // console.log(this.$store.getters)
  },


}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/president-mailbox/upload.vue